import { size, intersection, difference, has } from 'lodash/fp';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import {
  getUserPermissions,
  getUserPermissionsAsMap
} from '../../redux/selectors/permission';

const AccessControl = ({
  children,
  allowOnlyFor,
  allowWhenAny,
  allowWhenAll,
  fallback
}) => {
  const userPermissions = useSelector(getUserPermissions);
  const userPermissionsMap = useSelector(getUserPermissionsAsMap);
  const isAllowOnlyFor = allowOnlyFor
    ? has(allowOnlyFor, userPermissionsMap)
    : true;
  const isAllowWhenAny = size(allowWhenAny)
    ? size(intersection(allowWhenAny, userPermissions)) > 0
    : true;
  const isAllowWhenAll = size(allowWhenAll)
    ? size(difference(allowWhenAll, userPermissions)) === 0
    : true;

  return isAllowOnlyFor && isAllowWhenAny && isAllowWhenAll
    ? children
    : fallback;
};

AccessControl.propTypes = {
  children: PropTypes.node.isRequired,
  allowOnlyFor: PropTypes.string,
  allowWhenAny: PropTypes.arrayOf(PropTypes.string),
  allowWhenAll: PropTypes.arrayOf(PropTypes.string),
  fallback: PropTypes.node
};

AccessControl.defaultProps = {
  fallback: '',
  allowOnlyFor: '',
  allowWhenAny: [],
  allowWhenAll: []
};

export default AccessControl;
